import type React from 'react'

import { cn } from '@mntn-dev/ui-utilities'

import { useFormFieldContext } from './use-form-field.ts'

type FormFieldControlProps = Readonly<{
  children: React.ReactNode
  className?: string
}>

const FormFieldControl = ({ children, className }: FormFieldControlProps) => {
  const context = useFormFieldContext()

  return (
    <div className={cn(className, context?.hasError ? 'relative' : '')}>
      {children}
    </div>
  )
}

export { FormFieldControl, type FormFieldControlProps }
